import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class ResetPasswordRoute extends Route {
  @service declare store: StoreService;

  queryParams = {
    token: { refreshModel: true, replace: true },
  };

  async model() {
    const query = location.search;
    const params = new URLSearchParams(query);
    const token = params.get('token');
    // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
    const validationRes = await this.store.adapterFor('login').validateResetPasswordToken(token);

    if (!token || !validationRes?.success) {
      return {
        error: 'Invalid token',
      };
    }
  }
}
